import React, { useEffect, useState } from "react";
import "./Spandan_Register_Form.css";
import Breadcrumb_Comp from "../common/common_components/breadcrumb_comp/Breadcrumb_Comp";
import { Form } from "react-bootstrap";
import Select from "react-select";
import Common_Title_2 from "../common/common_components/common_title_2/Common_Title_2";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useForm, Controller } from "react-hook-form";
import Orange_Btn from "../common/common_btn/orange_btn/Orange_Btn";
import Common_Back_Header from "../common/common_components/common_back_header/Common_Back_Header";
import Successfull_Modal from "../common/modals/common-modal/successfull_modal/Successfull_Modal";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  AllCity,
  AllCountry,
  AllGenders,
  AllPincode,
  AllState,
  SpandanFormStatus,
} from "../../features/admin/common/Slice";
import {
  AllSpandan_Session_Type,
  SpandanRegistration,
} from "../../features/admin/spandan/Slice";
import { Select2Data } from "../../utils/common";
import useRazorpay from "react-razorpay";

import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import dayjs from "dayjs";


const Spandan_Register_Form = () => {
  const {
    control,
    reset,
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  const breadcrumbs = [
    { label: "SPANDAN", link: "/spandan", active: false },
    // {
    //   label: "PRANIC HEALING",
    //   link: "/panic-healing",
    //   active: false,
    // },
    { label: "registration", link: "", active: false },
  ];

  const options = [
    { value: "chocolate", label: "Chocolate" },
    { value: "strawberry", label: "Strawberry" },
    { value: "vanilla", label: "Vanilla" },
  ];

  const [successModal, setSuccessModal] = useState(false);
  const [sessionTypes, setSessionTypes] = useState(false);
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const genders = useSelector((state) => state.common.all_genders);

  const countries = useSelector((state) => state.common.all_country);
  const states = useSelector((state) => state.common.all_state);
  const cities = useSelector((state) => state.common.all_city);
  const pincodes = useSelector((state) => state.common.all_pincode);
  const sendData = new FormData();
  const spandanForm = useSelector((state) => state.common.spandan_form_status);

  useEffect(() => {
    dispatch(SpandanFormStatus());

    dispatch(AllCountry());
    dispatch(AllGenders());
    setSpandanSession();
  }, [dispatch]);

  const setSpandanSession = async () => {
    const res = await dispatch(AllSpandan_Session_Type());
    const sessionTypes = await Select2Data(res?.payload);
    await setSessionTypes(sessionTypes);
  };

  const RegisterSpandan = async (data) => {
    console.log("FFFFAAAAAAAAAA : ", data);

    sendData.append("name", data?.full_name);
    sendData.append("dob", data?.dob);
    sendData.append("email", data?.email);
    sendData.append("address", data?.address);
    sendData.append("contact_no", data?.phone);
    sendData.append("alt_phone", data?.alt_phone);

    sendData.append("country_id", data?.country_id?.value);
    sendData.append("state_id", data?.state_id?.value);
    sendData.append("city_id", data?.city_id?.value);
    sendData.append("pincode_id", data?.pincode_id?.value);
    sendData.append("gender_id", data?.gender_id?.value);
    sendData.append("spandan_session_id", data?.session_id?.value);

    // Log formdata properly
    for (let pair of sendData.entries()) {
      console.log(pair[0], pair[1]);
    }
    // await handleRazorpay(0)

    await finalFunction();
  };

  const [Razorpay] = useRazorpay();
  const handleRazorpay = async (price) => {
    const amountInPaise = Math.round(price * 100);
    const options = {
      key: "rzp_test_I05KCFb1v5JJRc",
      amount: amountInPaise,
      currency: "INR",
      name: "Khadyalay",
      description: "Test Transaction",
      image:
        "http://localhost:3000/static/media/hippicart-logo.427718645d3015dbf003.png",

      handler: async (res) => {
        // await setRazorId(res.razorpay_payment_id);
        finalFunction(res.razorpay_payment_id);
      },
      prefill: {
        name: "Piyush Garg",
        email: "youremail@example.com",
        contact: "9834474552",
      },
      notes: {
        address: "Razorpay Corporate Office",
      },
      theme: {
        color: "#052c65",
      },
    };

    const rzpay = new Razorpay(options);
    rzpay.open();
  };

  const finalFunction = async (razorpay) => {
    for (let pair of sendData.entries()) {
      console.log(pair[0], pair[1]);
    }
    if (razorpay) {
      sendData.append("razorpay_id", razorpay);
    }

    const res = await dispatch(SpandanRegistration(sendData));
    if (res.meta?.requestStatus === "fulfilled") {
      reset();
      setSuccessModal(true);
      setTimeout(() => {
        navigate(-1);
        setSuccessModal(false);
      }, 3000);
    } else if (res.meta?.requestStatus === "rejected") {
      alert(`${res?.payload?.errors}`);
    }
  };

  const isOn = (key) => spandanForm?.[key] === true;

  return (
    <section className="Personal_Info_Form Volunteer_step_form Spandan_Register_Form">
      <div className="container">
        <Breadcrumb_Comp data={breadcrumbs} />

        <Common_Title_2 subText={"Personal Information"} />

        <div className="form_sec">
          <div className="row">
            <div className="col-lg-12 mx-auto">
              <Form>
                {/* <Common_Back_Header  /> */}
                <Common_Back_Header backNavigation={-1} />
                <div className="row">
                  {isOn("full_name") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Full Name of Participant</Form.Label>
                        <Form.Control
                          type="text"
                          placeholder="Enter Full Name"
                          // {...register("full_name", {
                          //   required: isOn("full_name")
                          //     ? "Full Name is required"
                          //     : 0,
                          //   pattern: {
                          //     value: /^[A-Za-z.]+(?:\s[A-Za-z.]+)*$/,
                          //     message: "Enter a valid full name",
                          //   },
                          // })}
                          {...register("full_name", {
                            required: "Full name is required",
                            minLength: {
                              value: 3,
                              message: "Name must be at least 3 characters",
                            },
                            maxLength: {
                              value: 50,
                              message: "Name cannot exceed 50 characters",
                            },
                            pattern: {
                              value: /^[A-Za-z\s]+$/,
                              message: "Name can only contain letters and spaces",
                            },
                          })}
                        />
                        {errors?.full_name && (
                          <Form.Text className="text-danger">
                            {errors.full_name.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}

                  <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Session</Form.Label>
                      <Controller
                        name="session_id"
                        control={control}
                        rules={{ required: "Session is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={sessionTypes}
                            placeholder="Select Session"
                          />
                        )}
                      />
                      {errors?.session_id && (
                        <Form.Text className="text-danger">
                          {errors.session_id.message}
                        </Form.Text>
                      )}
                    </div>
                  </div>
                  {isOn("phone") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Phone Number</Form.Label>
                        <Form.Control
                          placeholder="Phone Number"
                          type="text"
                          name="phone"
                          maxLength={10} // restrict typing to 10 digits
                          {...register("phone", {
                            required: isOn("phone")
                              ? "Phone Number is required"
                              : false,
                            pattern: {
                              value: /^[0-9]+$/, // only numbers
                              message: "Only digits are allowed",
                            },
                            minLength: {
                              value: 10,
                              message: "Phone Number must be exactly 10 digits",
                            },
                            maxLength: {
                              value: 10,
                              message: "Phone Number must be exactly 10 digits",
                            },
                          })}
                        />
                        {errors?.phone && (
                          <Form.Text className="text-danger">
                            {errors.phone.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("alt_phone") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Alternate Phone Number</Form.Label>
                        <Form.Control
                          placeholder="Alternate Phone Number"
                          type="text"
                          name="phone"
                          maxLength={10} // restrict typing to 10 digits
                          {...register("alt_phone", {
                            pattern: {
                              value: /^[0-9]+$/, // only numbers
                              message: "Only digits are allowed",
                            },
                            minLength: {
                              value: 10,
                              message:
                                "Alternate Phone Number must be exactly 10 digits",
                            },
                            maxLength: {
                              value: 10,
                              message:
                                "Alternate Phone Number must be exactly 10 digits",
                            },
                          })}
                        />
                        {errors?.alt_phone && (
                          <Form.Text className="text-danger">
                            {errors.alt_phone.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("gender") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Gender</Form.Label>
                        <Controller
                          name="gender_id"
                          control={control}
                          rules={{
                            required: isOn("gender")
                              ? "Gender is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={genders}
                              placeholder="Select Gender"
                            />
                          )}
                        />
                        {errors?.gender_id && (
                          <Form.Text className="text-danger">
                            {errors.gender_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {/* {isOn("dob") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Date of Birth</Form.Label>
                        <Form.Control
                          type="date"
                          {...register("dob", {
                            required: isOn("dob") ? "DOB is required" : false,
                          })}
                          max={new Date().toISOString().split("T")[0]}
                        />

                        {errors?.dob && (
                          <Form.Text className="text-danger">
                            {errors.dob.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )} */}

                  {isOn("dob") && (
                    <div className="col-md-6 mb-3">
                      <div className="form-group">
                        <Form.Label>Date of Birth</Form.Label>

                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <Controller
                            name="dob"
                            control={control}
                            rules={{
                              required: isOn("dob") ? "DOB is required" : false,
                              validate: (value) => {
                                if (!value) return true;

                                const selectedDate = dayjs(value);
                                const today = dayjs().startOf("day");

                                if (selectedDate.isAfter(today)) {
                                  return "Future date is not allowed";
                                }

                                return true;
                              },
                            }}
                            render={({ field }) => (
                              <DatePicker
                                label="Select Date of Birth"
                                maxDate={dayjs().subtract(1, "day")}
                                value={field.value ? dayjs(field.value) : null}
                                onChange={(newValue) => {
                                  const formattedDate = newValue
                                    ? newValue.format("YYYY-MM-DD")
                                    : null;
                                  field.onChange(formattedDate);
                                }}
                                slotProps={{
                                  textField: {
                                    fullWidth: true,
                                    error: !!errors?.dob,
                                    helperText: errors?.dob?.message,
                                  },
                                }}
                              />
                            )}
                          />
                        </LocalizationProvider>
                      </div>
                    </div>
                  )}

                  {isOn("email") && (
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <Form.Label>Email*</Form.Label>
                        <Form.Control
                          type="email"
                          placeholder="Enter Email"
                          {...register("email", {
                            required: isOn("email")
                              ? "Email is required"
                              : false,
                            pattern: {
                              value: /^[a-zA-Z0-9]+([._%+-]?[a-zA-Z0-9]+)*@[a-zA-Z0-9-]+(\.[a-zA-Z]{2,})+$/,
                              message: "Enter a valid email address",
                            },
                          })}
                        />
                        {errors?.email && (
                          <Form.Text className="text-danger">
                            {errors.email.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {/* <div className="col-md-6 mb-3">
                    <div className="form-group">
                      <Form.Label>Country of Residence</Form.Label>
                      <Controller
                        name="country_id"
                        control={control}
                        rules={{ required: "Country is required" }}
                        render={({ field }) => (
                          <Select
                            {...field}
                            options={countries}
                            // getOptionLabel={(x) => x.name}
                            // getOptionValue={(x) => x.id}
                            placeholder="Select Country"
                          />
                        )}
                      />
                      {errors?.country_id && (
                        <Form.Text className="text-danger">{errors.country_id.message}</Form.Text>
                      )}
                    </div>
                  </div> */}
                  {isOn("country") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>Country of Residence</Form.Label>
                        <Controller
                          name="country_id"
                          control={control}
                          rules={{
                            required: isOn("country")
                              ? "Country is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={countries}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                setValue("state_id", null);
                                setValue("city_id", null);
                                setValue("pincode_id", null);
                                dispatch(
                                  AllState({ countryId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select Country"
                            />
                          )}
                        />
                        {errors?.country_id && (
                          <Form.Text className="text-danger">
                            {errors.country_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("state") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>State</Form.Label>
                        <Controller
                          name="state_id"
                          control={control}
                          rules={{
                            required: isOn("state")
                              ? "State is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={states}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                setValue("city_id", null);
                                setValue("pincode_id", null);
                                dispatch(
                                  AllCity({ stateId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select State"
                            />
                          )}
                        />
                        {errors?.state_id && (
                          <Form.Text className="text-danger">
                            {errors.state_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("city") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>City</Form.Label>
                        <Controller
                          name="city_id"
                          rules={{
                            required: isOn("city") ? "City is required" : false,
                          }}
                          control={control}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={cities}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                setValue("pincode_id", null);
                                dispatch(
                                  AllPincode({ cityId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select City"
                            />
                          )}
                        />
                        {errors?.city_id && (
                          <Form.Text className="text-danger">
                            {errors.city_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("pincode") && (
                    <div className="col-md-3 mb-3">
                      <div className="form-group">
                        <Form.Label>Postal Code</Form.Label>
                        <Controller
                          name="pincode_id"
                          control={control}
                          rules={{
                            required: isOn("pincode")
                              ? "Postal Code is required"
                              : false,
                          }}
                          render={({ field }) => (
                            <Select
                              {...field}
                              options={pincodes}
                              onChange={(selectedOption) => {
                                field.onChange(selectedOption);
                                dispatch(
                                  AllPincode({ cityId: selectedOption.value }),
                                );
                              }}
                              placeholder="Select Code"
                            />
                          )}
                        />
                        {errors?.pincode_id && (
                          <Form.Text className="text-danger">
                            {errors.pincode_id.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}

                  {/* </div> */}

                  {isOn("address") && (
                    <div className="col-md-12 mb-3">
                      <div className="form-group">
                        <Form.Label>Address</Form.Label>
                        <Form.Control
                          as="textarea"
                          placeholder="Enter Address"
                          {...register("address", {
                            required: isOn("address")
                              ? "Address is required"
                              : false,
                          })}
                        />
                        {errors?.address && (
                          <Form.Text className="text-danger">
                            {errors.address.message}
                          </Form.Text>
                        )}
                      </div>
                    </div>
                  )}
                  {isOn("acknowledgement") && (
                    <div className="col-md-12 mt-3 mb-3">
                      <div className="form-group">
                        <Form.Check
                          type="checkbox"
                          id="second"
                          label="I acknowledge that this experience is for personal growth and is not a medical substitute."
                          {...register("acknowledgement", {
                            required: isOn("acknowledgement")
                              ? "You must acknowledge this to continue"
                              : 0,
                          })}
                        />

                        {errors?.acknowledgement && (
                          <small className="text-danger">
                            {errors.acknowledgement.message}
                          </small>
                        )}
                      </div>
                    </div>
                  )}
                </div>
              </Form>

              <div className="btn_holder">
                <Orange_Btn
                  btnText={"Register"}
                  // onClick={() => {
                  //   setSuccessModal(true);
                  //   setTimeout(() => {
                  //     setSuccessModal(false);
                  //   }, 3000);
                  // }}
                  onClick={handleSubmit(RegisterSpandan)}
                  className="zoom_in_out"
                />
              </div>
            </div>
          </div>

          <Successfull_Modal
            show={successModal}
            onHide={() => setSuccessModal(false)}
            headtext={"The Spirit Of Spandan"}
            successfultext={
              "Welcome to Spandan! May this journey bring peace, joy, and transformation."
            }
            subtext={"Stay connected for divine updates "}
            subtext2={"and Sadguru’s grace-filled gatherings."}
          />
        </div>
      </div>
    </section>
  );
};

export default Spandan_Register_Form;
